<template>
    <v-flex
        v-if="service && service['document' + upperLocale]"
        class="text-center text-md-right my-2 mr-md-4"
    >
        <a :href="service['document' + upperLocale]" rel="noopener noreferrer" target="_blank">
            <v-menu>
                <template v-slot:activator="{ on: menu }">
                    <v-tooltip left>
                        <template v-slot:activator="{ on: tooltip }">
                            <v-icon
                                color="red"
                                :large="largeIcon"
                                v-on="{ ...tooltip, ...menu }"
                                v-text="'far fa-file-pdf'"
                            />
                        </template>
                        <div v-text="$t('appt.document')" />
                    </v-tooltip>
                </template>
            </v-menu>
        </a>
    </v-flex>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'service-pdf-link-icon',
    props: {
        service: { type: Object, required: false, default: () => undefined },
        largeIcon: { type: Boolean, required: false, default: false },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
    },
};
</script>
